// DEPLOY: /var/www/woody.wtf/frontend/src/chart/TextDialog.js
// Multi-line text entry for text drawings: Enter starts a new line, Done (or Ctrl/Cmd+Enter) finishes.
import React, { useState, useEffect, useRef } from 'react';

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
  box:     { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'calc(var(--radius) * 2)', boxShadow: '0 8px 32px rgba(0,0,0,0.2)', padding: '16px', width: '400px', maxWidth: '100%' },
  title:   { fontSize: '13px', fontWeight: 700, color: 'var(--text)', marginBottom: '8px' },
  area:    { width: '100%', minHeight: '110px', padding: '8px 10px', fontSize: '14px', fontFamily: "'Space Grotesk',sans-serif", border: '1px solid var(--border)', borderRadius: 'var(--radius)', background: 'var(--bg)', color: 'var(--text)', boxSizing: 'border-box', resize: 'vertical' },
  foot:    { display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '10px' },
  ghost:   { background: 'none', color: 'var(--text-muted)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '6px 14px', fontSize: '13px', cursor: 'pointer' },
  done:    { background: 'var(--accent)', color: 'var(--on-accent)', border: 'none', borderRadius: 'var(--radius)', padding: '6px 16px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' },
};

export default function TextDialog({ initial, onDone }) {
  const [text, setText] = useState(initial || '');
  const ref = useRef(null);
  // Opened from a press on the chart: focus now and again once that press is released
  // (the release would otherwise take focus back off the text box).
  useEffect(() => {
    const focus = () => ref.current?.focus();
    focus();
    window.addEventListener('pointerup', focus, { once: true });
    const t = setTimeout(focus, 80);
    return () => { window.removeEventListener('pointerup', focus); clearTimeout(t); };
  }, []);
  const finish = () => onDone(text.replace(/\s+$/, '') || null);
  return (
    <div style={S.overlay} onPointerDown={e => { if (e.target === e.currentTarget) onDone(null); }}>
      <div style={S.box}>
        <div style={S.title}>Text</div>
        <textarea ref={ref} style={S.area} value={text} onChange={e => setText(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) finish(); if (e.key === 'Escape') onDone(null); }} />
        <div style={S.foot}>
          <button style={S.ghost} onClick={() => onDone(null)}>Cancel</button>
          <button style={S.done} onClick={finish}>Done</button>
        </div>
      </div>
    </div>
  );
}
